
  export default {
    url: "",
    apiUrl: "/",
    realtimeServerAddress: "http://localhost:8901/"
  }


// WEBPACK FOOTER //
// ./src/config/product.js